import { defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

export const tableHeaderMessages = defineMessages({
  active: { id: "app.active", defaultMessage: "Active" },
  activeValue: { id: "app.active", defaultMessage: "Active" },
  inactiveValue: { id: "app.inactive", defaultMessage: "Inactive" },
  ticker: { id: "extras.tableHeader.id", defaultMessage: "Id" },
  translationsList: { id: "extras.tableHeader.name", defaultMessage: "Name" },
  codesList: { id: "extras.tableHeader.codes", defaultMessage: "Codes" },
  type: { id: "extras.tableHeader.type", defaultMessage: "Type" },
  variant: { id: "extras.tableHeader.variant", defaultMessage: "Variant" },
  rate: { id: "extras.tableHeader.rate", defaultMessage: "Rate" },
  travelWindow: { id: "extras.tableHeader.travelWindow", defaultMessage: "Validity (dates)" },
  availability: { id: "extras.tableHeader.availability", defaultMessage: "Availability" },
  blockage: { id: "extras.tableHeader.blockage", defaultMessage: "Block Validity" },
  minStay: { id: "extras.tableHeader.minStay", defaultMessage: "Min.Stay(d)" },
  maxStay: { id: "extras.tableHeader.maxStay", defaultMessage: "Max.Stay(d)" },
  minNotice: { id: "extras.tableHeader.minNotice", defaultMessage: "Min.Release(h)" },
  maxNotice: { id: "extras.tableHeader.maxNotice", defaultMessage: "Max.Release(h)" },
  lockType: { id: "extras.tableHeader.lockType", defaultMessage: "Blocking Behavior" },
  emailsList: { id: "extras.tableHeader.notificationEmails", defaultMessage: "Email" },
  isShared: { id: "extras.tableHeader.use", defaultMessage: "Use" },
  sharedUse: { id: "extras.list.use.shared", defaultMessage: "Shared" },
});

export const tableValuesMessages = defineMessages({
  rateTypeOwn: { id: "extras.tableValue.rateType.own", defaultMessage: "Own" },
});

export const tableFilterMessages = defineMessages({
  active: { id: "app.active", defaultMessage: "Active" },
  visible: { id: "app.visible", defaultMessage: "Visible" },
  name: { id: "extras.tableHeader.name", defaultMessage: "Name" },
  type: { id: "extras.tableHeader.type", defaultMessage: "Type" },
  code: { id: "extras.tableHeader.codes", defaultMessage: "Codes" },
  isShared: { id: "extras.tableHeader.use", defaultMessage: "Use" },
  typeRoom: { id: "extras.tableValue.type.room", defaultMessage: "Per room" },
  typePerson: { id: "extras.tableValue.type.person", defaultMessage: "Per person" },
  typeUnit: { id: "extras.tableValue.type.unit", defaultMessage: "Per unit" },
});

export const messages = {
  ...defaultCrudMessages,
  tableHeaders: tableHeaderMessages,
  entityName: {
    id: "extras.entityName",
    defaultMessage: "Extras",
  },
  delete: {
    id: "app.entityList.tooltip.delete",
    description: "Delete message",
    defaultMessage: "Delete",
  },
  view: {
    id: "app.entityList.tooltip.view",
    description: "view",
    defaultMessage: "view",
  },
  edit: {
    id: "app.entityList.tooltip.edit",
    description: "edit",
    defaultMessage: "edit",
  },
  drag: {
    id: "app.entityList.tooltip.reorder",
    description: "Reorder message",
    defaultMessage: "Reorder",
  },
  duplicate: {
    id: "app.entityList.tooltip.duplicate",
    description: "Duplicate message",
    defaultMessage: "Duplicate",
  },
  downloadExcel: {
    id: "app.entityList.downloadExcel",
    description: "Download excel",
    defaultMessage: "Download excel",
  }
};

export const filterMessages = defineMessages({
  accommodation: {
    id: "app.smartSelector.filter.accommodation",
    defaultMessage: "Accommodation",
  },
  conditions: {
    id: "app.smartSelector.filter.conditions",
    defaultMessage: "Conditions",
  },
  ocupation: {
    id: "app.smartSelector.filter.configuration",
    defaultMessage: "Configurations",
  },
  confirmation: {
    id: "app.smartSelector.filter.confirmation",
    defaultMessage: "Condition",
  },
  mealplan: {
    id: "app.smartSelector.filter.mealplan",
    defaultMessage: "Meal Plan"
  },
});

export const lockTypeMessage: {
  [key: string]: { id: string; defaultMessage: string };
} = {
  EXTRA_LOCK_TYPE_DAY: { id: "extras.tableValue.lock.type.day", defaultMessage: "Day" },
  EXTRA_LOCK_TYPE_STAY: { id: "extras.tableValue.lock.type.stay", defaultMessage: "Stay" },
};

export const typeMessage: {
  [key: string]: { id: string; defaultMessage: string };
} = {
  EXTRA_TYPE_ROOM: { id: "extras.form.type.room", defaultMessage: "Per room" },
  EXTRA_TYPE_ROOM_PER_DAY: { id: "extras.form.type.room.perDay", defaultMessage: "Per room/day" },
  EXTRA_TYPE_ROOM_MANDATORY: { id: "extras.form.type.room.mandatory", defaultMessage: "Per room (mandatory)" },
  EXTRA_TYPE_ROOM_PER_DAY_MANDATORY: { id: "extras.form.type.room.perDayMandatory", defaultMessage: "Per room/day (Mandatory)" },
  EXTRA_TYPE_ROOM_SPECIFIC_DATE: { id: "extras.form.type.room.specificDate", defaultMessage: "Per room/specific date" },
  EXTRA_TYPE_PERSON: { id: "extras.form.type.person", defaultMessage: "Per person" },
  EXTRA_TYPE_PERSON_PER_DAY: { id: "extras.form.type.person.perDay", defaultMessage: "Per person/day" },
  EXTRA_TYPE_PERSON_MANDATORY: { id: "extras.form.type.person.mandatory", defaultMessage: "Per person (mandatory)" },
  EXTRA_TYPE_PERSON_PER_DAY_MANDATORY: { id: "extras.form.type.person.perDayMandatory", defaultMessage: "Per person/day (Mandatory)" },
  EXTRA_TYPE_PERSON_SPECIFIC_DATE: { id: "extras.form.type.person.specificDate", defaultMessage: "Per person/specific date" },
  EXTRA_TYPE_UNIT: { id: "extras.form.type.unit", defaultMessage: "Per unit" },
  EXTRA_TYPE_UNIT_PER_DAY: { id: "extras.form.type.unit.day", defaultMessage: "Per unit/day" },
  EXTRA_TYPE_UNIT_SPECIFIC_DATE: { id: "extras.form.type.unit.specificDate", defaultMessage: "Per unit/Specific Date" },
};
